export default function TelegramLogo() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1C6.14391 1 4.36219 1.73795 3.05078 3.05023C1.73803 4.36304 1.00038 6.14345 1 8C1 9.85577 1.73828 11.6375 3.05078 12.9498C4.36219 14.262 6.14391 15 8 15C9.85609 15 11.6378 14.262 12.9492 12.9498C14.2617 11.6375 15 9.85577 15 8C15 6.14423 14.2617 4.36252 12.9492 3.05023C11.6378 1.73795 9.85609 1 8 1Z"
        fill="url(#paint0_linear_7685_40906)"
        className="path-fill"
      />
      <path
        d="M3.62125 7.91553C5.95375 6.89953 7.50875 6.22969 8.28625 5.90603C10.5087 4.9819 10.97 4.8214 11.2712 4.81597C11.3375 4.8149 11.485 4.83128 11.5812 4.90909C11.6612 4.97472 11.6837 5.06347 11.695 5.12578C11.705 5.18803 11.7187 5.3299 11.7075 5.44065C11.5875 6.70565 11.0662 9.7754 10.8012 11.1923C10.69 11.7918 10.4687 11.9928 10.255 12.0124C9.79 12.0552 9.4375 11.7054 8.9875 11.4105C8.28375 10.9489 7.88625 10.6617 7.2025 10.2113C6.4125 9.69078 6.925 9.40465 7.375 8.93715C7.4925 8.81478 9.54 6.9529 9.57875 6.78403C9.58375 6.7629 9.58875 6.68415 9.54125 6.64265C9.495 6.60103 9.42625 6.61528 9.37625 6.62653C9.305 6.64253 8.18125 7.38603 6.00125 8.8569C5.6825 9.07615 5.39375 9.18303 5.13375 9.1774C4.84875 9.17128 4.29875 9.0159 3.89 8.88315C3.39 8.72028 2.99125 8.63415 3.02625 8.35753C3.04375 8.21353 3.2425 8.06615 3.62125 7.91553Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7685_40906"
          x1="8"
          y1="1"
          x2="8"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AABEE" />
          <stop offset="1" stopColor="#229ED9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
